import clientAuth from "../clientAuth";
import client from "../client";

export default {

    GetDrugIndex: (page = 1,userData) => clientAuth.post(`admin/drug/index?page=${page}`,{ json: userData }),
    AddDrug: (userData) => clientAuth.post('admin/drug/store', { json: userData }),
    deleteDrug: (drugId) => clientAuth.delete(`admin/drug/destroy/${drugId}`),
    GetDrugById: (drugId) => clientAuth.get(`admin/drug/show/${drugId}`),
    UpdateDrug: (drugId, userData) => clientAuth.post(`admin/drug/update/${drugId}`, { json: userData }),
    ChangeDrugStatus: (drugId) => clientAuth.post(`admin/drug/active/deactive/${drugId}`),
    //   UserchangePassword: (userData) => clientAuth.post('session/admin/change-password', { json: userData }),

    // search drug 18-03-25
    searchDrug: (userData) => clientAuth.post('admin/drug/search', { json: userData }),
};